<p-panel>
  <ng-template pTemplate="header" *ngIf="ConfigExpansionComponent?.Title">
    <span class="p-panel-title ng-star-inserted padding-15">{{ConfigExpansionComponent?.Title}}</span>
  </ng-template>
  <ng-template pTemplate="icons">
    <ng-container *ngFor="let iconbutton of ConfigExpansionComponent?.IconButton">
      <p-button
        icon="pi pi-plus"
        styleClass="{{iconbutton?.GetButtonClass()?.styleClass ?? 'p-button-text'}}"
        [label]="getHeaderTitle(iconbutton?.GetButtonClass()?.title) ?? ''"
        (onClick)="iconbutton?.GetButtonAction()"
        [disabled]="iconbutton?.GetDisableAction()"
      />
    </ng-container>
  </ng-template>
  <p-table
      [value]="ConfigExpansionComponent?.Data ?? []"
      [scrollable]="true"
      [tableStyle]="{ 'min-width': '50rem', 'border-radius': '10px' }"
      styleClass="p-datatable-sm p-datatable-striped border-solid border-1 surface-border border-round-sm"
      [groupRowsBy]="dataKey"
  >
    <ng-template pTemplate="header">
      <tr>
        <th></th>
        <th *ngFor="let header of ConfigExpansionComponent?.Columns"
          [pSortableColumnDisabled]="!header.GetSort()"
          [pSortableColumn]="header.GetPropertyName()"
        >
          {{ header.GetName() }}
          <p-sortIcon
              [field]="header.GetPropertyName()"
              *ngIf="header.GetSort()"
          />
        </th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-item
      let-rowIndex="rowIndex"
      let-expanded="expanded">
      <tr class="p-table-hover">
        <td>
          <button type="button"
            pButton pRipple [pRowToggler]="item"
            class="p-button-text p-button-rounded p-button-plain"
            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
          ></button>
        </td>
        <td *ngIf="ConfigExpansionComponent?.LineNumbers">
          <div class="flex align-items-center gap-2" style="min-width: 30px">
            {{ rowIndex + 1 }}
          </div>
        </td>
        <ng-container *ngFor="let column of ConfigExpansionComponent?.Columns">
          <td *ngIf="column.GetPropertyName()">
            <div
            [ngSwitch]="column.GetColumnType()"
            >
              <div
              *ngSwitchCase="ColumnTypeEnum.TextColumn"
              >
                <a [pTooltip]="getTooltip(column?.GetTooltip(), item[column.GetPropertyName()])">
                  {{
                    getValue(column.GetValue(), item[column.GetPropertyName()])
                  }}
                </a>
              </div>
              <div
              *ngSwitchCase="ColumnTypeEnum.DateColumn"
              >
                <a [pTooltip]="getTooltip(column?.GetTooltip(), item[column.GetPropertyName()])">
                  {{
                    getValue(column.GetValue(), item[column.GetPropertyName()])
                  }}
                </a>
              </div>
              <div
              *ngSwitchCase="ColumnTypeEnum.CurrencyColumn"
              >
                <a [pTooltip]="getTooltip(column?.GetTooltip(), item[column.GetPropertyName()])">
                  {{
                    getValue(column.GetValue(), item[column.GetPropertyName()])
                  }}
                </a>
              </div>
              <div
              *ngSwitchCase="ColumnTypeEnum.IconColumn"
              >
                <i
                  class="pi pi-{{
                    getValue(column.GetValue(), item[column.GetPropertyName()])}}"

                  style="font-size: 1rem"
                  [pTooltip]="getTooltip(column?.GetTooltip(), item[column.GetPropertyName()])">
                </i>
              </div>
              <div
              *ngSwitchCase="ColumnTypeEnum.LabelColumn"
              >
                <p-badge
                  [value]="getValue(column.GetValue(), item[column.GetPropertyName()])"
                  [severity]="column?.GetSeverity(item[column.GetPropertyName()])"

                  [pTooltip]="getTooltip(column?.GetTooltip(), item[column.GetPropertyName()])"/>
              </div>
              <div
              *ngSwitchCase="ColumnTypeEnum.ButtonColumn"
              >
                <p-button
                  [hidden]="!column?.GetIsVisible(item)"
                  [icon]="getIcon(column?.GetColumnClassProperties()?.icon, item) ?? 'pi pi-eye'"
                  [label]="getTitle(column?.GetColumnClassProperties()?.title,item) ?? ''"
                  styleClass="p-button-rounded p-button-text {{getStyleClass(column?.GetColumnClassProperties()?.styleClass,item) ?? 'p-button-info'}}"
                  [style]="column?.GetColumnClassProperties()?.style ?? { width: '35px', height: '35px' }"

                  [pTooltip]="getTooltip(column?.GetColumnClassProperties()?.pTooltip) ?? ''"
                  [tooltipPosition]="column?.GetColumnClassProperties()?.tooltipPosition ?? 'left'"
                  (onClick)="column?.GetAction(item, $event)"
                  [disabled]="column?.GetIsDisabled(item) ?? false"
                />
              </div>
            </div>
          </td>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="rowexpansion"
      let-item
    >
      <tr>
        <td colspan="7">
          <div class="p-p-3">
            <ng-container
              *ngTemplateOutlet="expandTemplate; context: {$implicit: item}">
            </ng-container>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-panel>
